import type { AgentBox } from '../types';
import styles from './StatusBadge.module.css';

const STATUS_LABELS: Record<AgentBox['status'], string> = {
  Creating: 'Creating',
  Running: 'Running',
  Stopped: 'Stopped',
  Failed: 'Failed',
  Deleted: 'Deleted',
  Destroying: 'Destroying',
};

export default function StatusBadge({ status }: { status: AgentBox['status'] }) {
  return (
    <span className={`${styles.badge} ${styles[status]}`}>
      {STATUS_LABELS[status]}
    </span>
  );
}
